;(function () {
  angular
    .module('contrast.security-controls')
    .controller('SecurityControlCtrl', SecurityControlCtrl)

  function SecurityControlCtrl(
    $scope,
    $filter,
    $interval,
    $q,
    $translate,
    $timeout,
    $routeParams,
    $location,
    dialogs,
    logger,
    RuleService,
    PromiseService,
    UserService,
    LanguagesService,
    securityControlService,
    SECURITY_CONTROL_TYPES
  ) {
    'ngInject'

    var delay = 500 //ms to simulate the infinite scroll

    angular.extend($scope, {
      model: {
        numPerPage: 15,
        currentPage: 1,
        busy: true,
        show_suggestions: true,
        show_notification: false,
        relevantAgentLanguages: []
      },
      searchKeywords: '',
      filteredControls: [],
      displayedControls: [],
      suggestions: [],
      totalSuggestions: 0,
      removed: {
        type: '',
        id: ''
      },
      orgUuid: $routeParams.orgUuid,
      row: 'api',
      control_types: securityControlService.getUserDefineControlTypes(),
      quickFilters: [],
      selectedQuickFilter: {
        name: 'All',
        filterType: 'ALL',
        count: '?'
      }
    })

    angular.extend($scope, {
      filterByText: filterByText,
      loadControlsByFilterChange: loadControlsByFilterChange,
      loadControlsByScroll: loadControlsByScroll,
      order: order,
      updateApi: updateApi,
      updateModule: updateModule,
      updateControl: updateControl,
      changeEnabled: changeEnabled,
      toggleSuggestions: toggleSuggestions,
      updateApiSuggested: updateApiSuggested,
      updateNameSuggested: updateNameSuggested,
      hideLanguage: hideLanguage,
      updateTypeSuggested: updateTypeSuggested,
      removeSuggestion: removeSuggestion,
      addSuggestion: addSuggestion,
      closeNotification: closeNotification,
      undo: undo,
      quickFilterSelect: quickFilterSelect,
      canEdit: canEdit,
      getLanguageDisplayValue: getLanguageDisplayValue
    })

    function init(isFirstLoad) {
      if (isFirstLoad && UserService.isFreemiumOrganization()) {
        $scope.selectedQuickFilter = {
          name: 'JAVA',
          filterType: 'JAVA',
          count: '?'
        }
      }

      $scope.controlsPromise = loadSecurityControls()

      var promises = {
        controlsPromise: $scope.controlsPromise,
        suggestedControls: loadSuggestedControls(),
        quickFilters: _getQuickFilters(),
        agentLanguages: LanguagesService.loadAgentLanguages()
      }

      $q.all(promises).then(function (responses) {
        $scope.model.busy = true
        $scope.displayedControls = []
        $scope.filteredControls = $filter('orderBy')(
          $scope.controls,
          $scope.row
        )
        loadControls(0, $scope.model.numPerPage)
        handleAgentLanguagesResponse(responses.agentLanguages)
      })
    }

    function handleAgentLanguagesResponse(agentLanguages) {
      $scope.model.relevantAgentLanguages =
        securityControlService.filterRelevantAgentLanguages(agentLanguages)
    }

    function quickFilterSelect(filter) {
      $scope.selectedQuickFilter = filter
      init(false)
    }

    function _getQuickFilters() {
      if ($scope.quickFiltersPromise) {
        PromiseService.cancelPromise($scope.quickFiltersPromise)
      }

      var data = {
        q: $scope.searchKeywords
      }

      $scope.quickFiltersPromise = securityControlService
        .getSecurityControlsQuickFilters(data)
        .then(function (filters) {
          $scope.quickFilters = filters
          $scope.selectedQuickFilter = $scope.quickFilters.find(function (
            filter
          ) {
            return filter.filterType == $scope.selectedQuickFilter.filterType
          })
        })

      return $scope.quickFiltersPromise
    }

    function loadSecurityControls() {
      var params = {
        quickFilter: $scope.selectedQuickFilter.filterType,
        q: $scope.searchKeywords
      }

      return securityControlService
        .getSecurityControls(params)
        .then(function (controls) {
          $scope.controls = defineApiOrPattern(controls)
        })
    }

    function defineApiOrPattern(controls) {
      controls.forEach(function (control) {
        control.apiOrPattern = control.pattern ? control.pattern : control.api
      })

      return controls
    }

    function loadSuggestedControls(keyword) {
      var params = {
        quickFilter: $scope.selectedQuickFilter.filterType,
        q: keyword
      }

      return securityControlService
        .getSuggestedControls(params)
        .then(function (suggestions) {
          $scope.suggestions = suggestions
          if (angular.isUndefined(keyword) || keyword.length == 0) {
            $scope.totalSuggestions = $scope.suggestions.length
          }
          var sanitizers = angular.isUndefined($location.search()['sanitizers'])
            ? []
            : $location.search()['sanitizers'].split(',')
          var validators = angular.isUndefined($location.search()['validators'])
            ? []
            : $location.search()['validators'].split(',')
          var validationResult,
            i = 0
          for (; i < $scope.suggestions.length; i++) {
            if (
              $scope.suggestions[i].type ==
              SECURITY_CONTROL_TYPES.PATTERN_VALIDATOR.value
            ) {
              $scope.suggestions[i].valid = true
            } else {
              validationResult = RuleService.validateApi(
                $scope.suggestions[i].api,
                $scope.suggestions[i].language
              )
              if (validationResult.result) {
                $scope.suggestions[i].valid = true
              } else {
                $scope.suggestions[i].valid = false
              }
            }

            $scope.suggestions[i].modifiedType = $scope.suggestions[i].type
            if (
              $scope.suggestions[i].type ==
              SECURITY_CONTROL_TYPES.INPUT_VALIDATOR.value
            ) {
              if (
                validators.indexOf($scope.suggestions[i].suggestion_id + '') !=
                -1
              ) {
                $scope.suggestions[i].highlight = true
              }
            } else {
              if (
                sanitizers.indexOf($scope.suggestions[i].suggestion_id + '') !=
                -1
              ) {
                $scope.suggestions[i].highlight = true
              }
            }
          }
        })
    }

    function filterByText() {
      loadControlsByFilterChange()
      loadSuggestedControls($scope.searchKeywords)
      _getQuickFilters()
    }

    function toggleSuggestions() {
      $scope.model.show_suggestions = !$scope.model.show_suggestions
    }

    function filterFunction(control) {
      var val = $scope.searchKeywords.toLowerCase()

      return (
        control.apiOrPattern.toLowerCase().indexOf(val || '') ||
        control.name.toLowerCase().indexOf(val || '') !== -1 ||
        control.language.toLowerCase().indexOf(val || '') !== -1
      )
    }

    function loadControls(offset, limit) {
      closeNotification()
      var addedControls
      if ($scope.filteredControls.length <= offset + limit) {
        addedControls = angular.copy(
          $scope.filteredControls.slice(offset, $scope.filteredControls.length)
        )
        $scope.displayedControls =
          $scope.displayedControls.concat(addedControls)
      } else {
        addedControls = angular.copy(
          $scope.filteredControls.slice(offset, offset + limit)
        )
        $scope.displayedControls =
          $scope.displayedControls.concat(addedControls)
      }
      $scope.model.busy = false
      $scope.model.currentPage = $scope.model.currentPage + 1

      $timeout(function () {
        $scope.$emit('triggerScrollCheck')
      })
    }

    function loadControlsByFilterChange() {
      $scope.model.busy = true
      $scope.displayedControls = []
      var deferred = $q.defer()
      $scope.controlsPromise = deferred.promise
      //This timeout is to simulate the infinite scroll, until the pagination (offset and limit) is done in client side
      $interval(
        function () {
          $scope.displayedControls = []
          $scope.model.currentPage = 1
          $scope.filteredControls = $filter('filter')(
            $scope.controls,
            filterFunction,
            $scope.searchKeywords
          )
          $scope.filteredControls = $filter('orderBy')(
            $scope.filteredControls,
            $scope.row
          )
          loadControls(0, $scope.model.numPerPage)
          deferred.resolve('')
        },
        delay,
        1
      )
    }

    function loadControlsByScroll() {
      var displayedCount = $scope.displayedControls.length,
        filteredCount = $scope.filteredControls.length

      if (displayedCount == filteredCount || filteredCount == 0) {
        return
      }

      $scope.model.busy = true
      var deferred = $q.defer()
      $scope.controlsPromise = deferred.promise
      //This timeout is to simulate the infinite scroll, until the pagination (offset and limit) is done in client side
      $interval(
        function () {
          loadControls(
            ($scope.model.currentPage - 1) * $scope.model.numPerPage,
            $scope.model.numPerPage
          )
          deferred.resolve('')
        },
        delay,
        1
      )
    }

    function order(rowName) {
      if ($scope.row === rowName) {
        return
      }
      $scope.model.busy = true
      var controlsLoaded = $scope.displayedControls.length
      $scope.row = rowName
      $scope.displayedControls = []
      var deferred = $q.defer()
      $scope.controlsPromise = deferred.promise
      $interval(
        function () {
          $scope.displayedControls = []
          $scope.filteredControls = $filter('filter')(
            $scope.controls,
            filterFunction,
            $scope.searchKeywords
          )
          $scope.filteredControls = $filter('orderBy')(
            $scope.filteredControls,
            $scope.row
          )
          loadControls(0, controlsLoaded)
          deferred.resolve('')
        },
        delay,
        1
      )
    }

    function updateApi(data, control) {
      if (control.api != data) {
        var newSecurityControl = {
          name: control.name,
          api: data,
          module: control.module,
          language: control.language,
          all_rules: control.allRules,
          rules: _.map(control.rules, 'name')
        }
        return updateControl(newSecurityControl, control.id)
      }
      return true
    }

    function updateModule(data, control) {
      if (control.module != data) {
        var newSecurityControl = {
          name: control.name,
          api: control.api,
          module: data,
          language: control.language,
          all_rules: control.allRules,
          rules: _.map(control.rules, 'name')
        }
        return updateControl(newSecurityControl, control.id)
      }
      return true
    }

    function updateControl(control, id) {
      var validationResult = RuleService.validateApi(
        control.api,
        control.language
      )
      if (validationResult.result) {
        return securityControlService
          .updateSecurityControl(id, control)
          .then(function (messages) {
            closeNotification()
            logger.logSuccess(messages[0])
            loadSecurityControls()
          })
      } else {
        if (validationResult.message) {
          return validationResult.result
        } else {
          var translations = {}
          translations.invalidApi = $translate.instant('validation_invalidAPI')

          return translations.invalidApi
        }
      }
    }

    function changeEnabled(control) {
      $scope.updatingEnabled = true
      return securityControlService
        .toogleControlEnabled(control.id)
        .then(loadSecurityControls)
        .finally(function () {
          $scope.updatingEnabled = false
        })
    }

    function updateApiSuggested(data, suggested) {
      var validationResult = RuleService.validateApi(data, suggested.language)
      if (validationResult.result) {
        suggested.valid = true
      } else {
        suggested.valid = false
        if (validationResult.message) {
          return validationResult.result
        } else {
          var translations = {}
          translations.invalidApi = $translate.instant('validation_invalidAPI')
          return translations.invalidApi
        }
      }
    }

    function updateNameSuggested(data, suggestion) {
      if (data == '') {
        var translations = {}
        translations.requiredName = $translate.instant(
          'validation_updateNameSuggested_requiredName'
        )
        return translations.requiredName
      }
      suggestion.hide_language = false
    }

    function hideLanguage(suggestion) {
      suggestion.hide_language = true
    }

    function updateTypeSuggested(data, suggested) {
      if (data == SECURITY_CONTROL_TYPES.INPUT_VALIDATOR.value) {
        suggested.modifiedType = SECURITY_CONTROL_TYPES.INPUT_VALIDATOR.value
      } else {
        suggested.modifiedType = SECURITY_CONTROL_TYPES.SANITIZER.value
      }
    }

    function removeSuggestion(suggestion) {
      var translations = {
        dialogTitle: $translate.instant('title_pleaseConfirmAction'),
        dialogDescription: $translate.instant(
          'detail_removeSuggestionDialog_removeConfirmation'
        ),
        dialogYes: $translate.instant('action_remove'),
        dialogNo: $translate.instant('action_cancel')
      }

      dialogs
        .confirm(translations.dialogTitle, translations.dialogDescription, {
          size: 'sm',
          yes: translations.dialogYes,
          no: translations.dialogNo
        })
        .result.then(function () {
          securityControlService
            .removeSuggestedControl(suggestion.suggestion_id)
            .then(function () {
              removeRow(suggestion)
              $scope.removed = {
                type: suggestion.type,
                id: suggestion.suggestion_id
              }
              $scope.model.show_notification = true
            })
        })
    }

    function removeRow(row) {
      var index = _.findIndex($scope.suggestions, function (sug) {
        return sug.suggestion_id == row.suggestion_id && sug.type == row.type
      })
      if (index != -1) {
        $scope.suggestions.splice(index, 1)
      }
    }

    function addSuggestion(suggestion) {
      if (suggestion.valid) {
        var form = {
          name: suggestion.name,
          api: suggestion.api,
          language: suggestion.language,
          type: suggestion.modifiedType,
          module: suggestion.module,
          pattern: suggestion.pattern
        }

        return securityControlService
          .addSuggestedControl(suggestion.suggestion_id, form)
          .then(function (response) {
            var control = response.data.control
            addSecurityControl(suggestion, {
              id: control.id,
              type: control.type,
              all_rules: true,
              enabled: true,
              language: control.language,
              name: control.name,
              api: control.api,
              module: control.module,
              pattern: control.pattern
            })
            logger.logSuccess(response.data.messages[0])
          })
      }
    }

    function addSecurityControl(suggestion, form) {
      closeNotification()
      loadSecurityControls()

      form.adding = true
      $timeout(function () {
        form.adding = false
      }, 1000)
      $scope.displayedControls.push(form)
      $scope.filteredControls.push(form)

      suggestion.adding = true

      $timeout(function () {
        removeRow(suggestion)
      }, 100)
    }

    function closeNotification() {
      $scope.model.show_notification = false
    }

    function undo() {
      return securityControlService
        .undoSuggestedControl($scope.removed.id)
        .then(function (suggestion) {
          $scope.suggestions.push(createSuggest(suggestion))
        })
        .finally(function () {
          closeNotification()
        })
    }

    function createSuggest(data) {
      var suggested = {
        api: data.api,
        apps: data.apps,
        language: data.language,
        name: data.name,
        pattern: data.pattern,
        suggestion_id: data.suggestion_id,
        type: data.type,
        user_exists: data.user_exists,
        username: data.username,
        modifiedType: data.type
      }

      if (suggested.type == SECURITY_CONTROL_TYPES.PATTERN_VALIDATOR.value) {
        suggested.valid = true
      } else {
        var validationResult = RuleService.validateApi(
          suggested.api,
          suggested.language
        )
        suggested.valid = validationResult.result
      }

      return suggested
    }

    function canEdit(value) {
      return value.type !== SECURITY_CONTROL_TYPES.PATTERN_VALIDATOR.value
    }

    function getLanguageDisplayValue(languageValue) {
      var agentLanguage = $scope.model.relevantAgentLanguages.find(function (
        agentLanguage
      ) {
        return agentLanguage.value === languageValue
      })

      return typeof agentLanguage !== 'undefined' ? agentLanguage.display : ''
    }

    init(true)
  }
})()
